module.exports = __webpack_public_path__ + "static/media/K-ICT03_04_help.99807d70.png";